window.initCartDrawerRecommendedSwiper = function () {
    document.querySelectorAll('.cart-recommand-product-mySwiper').forEach(function (el) {
        const section = el.closest('.cart-recommand__sec');
        if (!section) return;

        const prevButton = section.querySelector('.prev-btn');
        const nextButton = section.querySelector('.next-btn');
        const progressBar = section.querySelector('.cart-recommand-progress');

        if (el.swiper) {
            el.swiper.destroy(true, true);
        }

        new Swiper(el, {
            loop: false,
            slidesPerView: 1,
            spaceBetween: 10,
            navigation: {
                prevEl: prevButton,
                nextEl: nextButton,
            },
            pagination: {
                el: progressBar,
                type: 'progressbar',
            },
            breakpoints: {
                750: {
                    slidesPerView: 1.3,
                    spaceBetween: 14,
                },
                990: {
                    slidesPerView: 1.5,
                    spaceBetween: 16,
                },
            },
        });
    });
}
initCartDrawerRecommendedSwiper ();

document.addEventListener('click', (e) => {

  const sortBtn = e.target.closest('.sort-by-wrapper');

  if (sortBtn) {
    e.stopPropagation();

    const wrapper = sortBtn.closest('.custom-sort-container');
    const sortList = wrapper.querySelector('.sort-by-list');

    document.querySelectorAll('.sort-by-list').forEach(list => {
      if (list !== sortList) {
        list.classList.remove('show');
      }
    });

    sortList.classList.toggle('show');
    return;
  }

  const sortItem = e.target.closest('.sort-by-list li');

  if (sortItem) {

    const wrapper = sortItem.closest('.custom-sort-container');
    const sortList = wrapper.querySelector('.sort-by-list');
    const selectValue = wrapper.querySelector('.select-value');

    const value = sortItem.dataset.sortValue;
    const label = sortItem.textContent.trim();

    selectValue.textContent = label;

    sortList.querySelectorAll('li').forEach(li => {
      li.classList.remove('is-active');
    });

    sortItem.classList.add('is-active');
    sortList.classList.remove('show');

    const desktopSort = document.getElementById('SortByDesktop');
    const mobileSort = document.getElementById('SortBy-mobile');

    if (desktopSort) {
      desktopSort.value = value;
      desktopSort.dispatchEvent(
        new Event('change', { bubbles: true })
      );
    }

    if (mobileSort) {
      mobileSort.value = value;
      mobileSort.dispatchEvent(
        new Event('change', { bubbles: true })
      );
    }

    return;
  }

  document.querySelectorAll('.sort-by-list').forEach(list => {
    list.classList.remove('show');
  });


  
});


// document.addEventListener('DOMContentLoaded', function () {

//   function updateFacetTop() {

//     const announcement =
//       document.querySelector('[id*="announcement-bar"]');

//     const header =
//       document.querySelector('.section-header');

//     const announcementHeight = announcement
//       ? announcement.getBoundingClientRect().height
//       : 0;

//     const headerHeight = header
//       ? header.getBoundingClientRect().height
//       : 0;

//     const totalHeight = announcementHeight + headerHeight + 20;

//     document.querySelectorAll('.facets-container').forEach(function (el) {
//       el.style.setProperty(
//         'top',
//         Math.round(totalHeight) + 'px',
//         'important'
//       );
//     });

//     console.log('Announcement Height:', announcementHeight);
//     console.log('Header Height:', headerHeight);
//     console.log('Total Height:', totalHeight);
//   }

//   updateFacetTop();

//   window.addEventListener('load', updateFacetTop);
//   window.addEventListener('resize', updateFacetTop);
//   window.addEventListener('scroll', updateFacetTop);

//   const resizeObserver = new ResizeObserver(() => {
//     updateFacetTop();
//   });

//   const announcement =
//     document.querySelector('[id*="announcement-bar"]');

//   const header =
//     document.querySelector('.section-header');

//   if (announcement) {
//     resizeObserver.observe(announcement);
//   }

//   if (header) {
//     resizeObserver.observe(header);
//   }
// });

document.addEventListener('DOMContentLoaded', function () {

  function updateFacetTop() {

    if (window.innerWidth <= 749) {
      document.querySelectorAll('.facets-container').forEach(function (el) {
        el.style.removeProperty('top');
      });
      return;
    }

    const announcement =
      document.querySelector('[id*="announcement-bar"]');

    const header =
      document.querySelector('.section-header');

    const announcementHeight = announcement
      ? announcement.getBoundingClientRect().height
      : 0;

    const headerHeight = header
      ? header.getBoundingClientRect().height
      : 0;

    const totalHeight = announcementHeight + headerHeight + 20;

    document.querySelectorAll('.facets-container').forEach(function (el) {
      el.style.setProperty(
        'top',
        Math.round(totalHeight) + 'px',
        'important'
      );
    });
  }

  updateFacetTop();

  window.addEventListener('load', updateFacetTop);
  window.addEventListener('resize', updateFacetTop);

  const resizeObserver = new ResizeObserver(updateFacetTop);

  const announcement =
    document.querySelector('[id*="announcement-bar"]');

  const header =
    document.querySelector('.section-header');

  if (announcement) resizeObserver.observe(announcement);
  if (header) resizeObserver.observe(header);
});